export const inventorySearchReducer = function reducer(state, action) {
  switch (action.type) {
    case "SET_DB_INVENTORIES":
      return {
        ...state,
        dbInventories: action.payload,
      };
    case "SET_SEARCH_INVENTORIES":
      return {
        ...state,
        searchInventories: action.payload,
      };
    case "SET_INVENTORY_ITEM_SCANNED_BARCODE":
      return {
        ...state,
        scannedBarcode: action.payload,
      };
    case "SET_ALL_ACCOUNTS":
      return {
        ...state,
        allAccounts: action.payload,
      };

    case "SET_AREAS":
      return {
        ...state,
        areas: action.payload,
      };
    case "SET_ZONES":
      return {
        ...state,
        zones: action.payload.zones,
        aisles: action.payload.aisles,
      };
    case "SET_AISLES":
      return {
        ...state,
        aisles: action.payload,
      };
    case "SET_SELECTED_AREA":
      return {
        ...state,
        zones: action.payload.zones,
        selectedArea: action.payload.selectedArea,
        selectedZone: action.payload.zone,
        selectedAisle: null,
        selectedLocation: null,
      };
    case "SET_SELECTED_ZONE":
      return {
        ...state,
        selectedZone: action.payload,
        selectedAisle: null,
        selectedLocation: null,
      };
    case "SET_SELECTED_AISLE":
      return {
        ...state,
        selectedAisle: action.payload.aisle,
        bayList: action.payload.bayList,
        showCapacityDisplay: action.payload.showCapacityDisplay,
        selectedLocation: action.payload.selectedLocation,
        inventoryItemBayList: action.payload.inventoryItemBayList,
      };
    case "SET_SELECTED_INVENTORY_ITEM":
      return {
        ...state,
        currentInventory: action.payload.inventory,
        selectedInventoryItem: { ...action.payload },
      };
    // An inventory item whose locationId holds the UNSPOTTED_VIRTUAL sentinel --
    // written by the handleTrackCarChange lambda when a railcar is un-spotted,
    // and never a real Location row -- resolves no location at all. Seeding the
    // destination selects off a location that does not exist threw before the
    // page could render; leaving them empty instead shows the item as unlocated
    // and lets the crew relocate it somewhere real, which turns that data bug
    // into a self-service repair. originalLocation and originalInventoryItem are
    // stored exactly as they arrive because the "from" display reads them.
    case "SET_ORIGINAL_INVENTORY_ITEM":
      return {
        ...state,
        selectedArea: action.payload.location?.area ?? null,
        selectedZone: action.payload.location?.zone ?? null,
        selectedAisle: action.payload.location?.aisle ?? null,
        originalLocation: action.payload.location,
        originalInventoryItem: action.payload,
      };
    case "CLEAR_INVENTORY_ITEM":
      return {
        ...state,
        selectedInventoryItem: null,
        selectedArea: null,
        selectedZone: null,
        selectedAisle: null,
        originalLocation: null,
        originalInventoryItem: null,
        selectedLocation: null,
        bayList: null,
        inventoryItemBayList: null,
        selectedSearchAisleId: "",
      };
    case "UPDATE_CURRENT_INVENTORY":
      return {
        ...state,
        currentInventory: { ...action.payload },
      };
    case "UPDATE_INVENTORY_ITEM":
      return {
        ...state,
        selectedInventoryItem: { ...action.payload },
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_SELECTED_LOCATION":
      return {
        ...state,
        selectedLocation: action.payload.location,
      };
    case "SET_DISABLE_VALIDATION":
      return {
        ...state,
        disableRelocateValidation: action.payload,
      };
    case "SET_SELECTED_LOCATION_INVENTORIES":
      return {
        ...state,
        selectedLocationInventories: action.payload,
      };
    case "SET_AISLE_SEARCH_INVENTORIES":
      return {
        ...state,
        searchInventoryItemsMap: action.payload,
      };
    case "SET_SHOW_QUANTITY":
      return {
        ...state,
        showInventoryQuantity: action.payload,
      };
    case "SET_SEARCH_AISLES":
      return {
        ...state,
        searchAisles: action.payload,
      };
    case "SET_SEARCH_SELECTED_AISLE":
      return {
        ...state,
        selectedSearchAisleId: action.payload,
      };
    case "NO_SEARCH":
      return {
        ...state,
        noSearch: action.payload,
      };
    case "CLEAR_SEARCH":
      return {
        ...state,
        selectedSearchAisleId: "",
        searchInventories: [],
        dbInventories: [],
        noSearch: true,
      };
    default:
      break;
  }
  return state;
};
